import { useApolloClient } from '@apollo/react-hooks';

import useStores from 'shared/hooks/use-stores';
import { useCheckout } from 'checkout/context';
import { useIsolatedCheckout } from 'checkout/isolated/context';
import { CheckoutVariants } from 'src/constants/checkout-variants';

export default function useStoreMap() {
  // the "stores" object is stable, so mutating it here works
  const stores = useStores();
  const CheckoutCtx = useCheckout();
  useIsolatedCheckout();
  const apolloClient = useApolloClient();

  stores.Cart = stores.cart;
  stores.User = stores.user;
  stores.apolloClient = apolloClient;

  if (stores.UI) {
    CheckoutCtx.showErnie = stores.UI.showErnie;
    CheckoutCtx.variant = CheckoutVariants.isolatedCheckout;
    CheckoutCtx.openOrderTypeModal = stores.UI.openOrderTypeModal;
  }

  // here we need to map action items from the cart to new action items in the isolated context.

  return stores;
}
